import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../../../../config';

@Injectable()
export class ImportService {
  constructor(private http: HttpClient) {}

  communications(data: any) {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/v1/admin/imports/communications`, data);
  }

  customerContactDetails(mode: string, file: File) {
    const body = new FormData();
    body.append('mode', mode);
    body.append('file', file, file.name);

    return this.http
      .post<{ data: any}>(`${config.apiLocation}/v1/admin/imports/contact-details`, body);
  }

  debts(client_id: string, data: any) {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/v1/clients/${client_id}/import/debts`, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/imports/import.service.ts